var e = {
	title: "Action Required",
	titleWithCount: "Action Required ({{count}})",
	viewAll: "View all",
	empty: "You're all caught up",
	emptyHint: "New booking requests and anything needing your attention will show up here.",
	waitingGroup_one: "{{count}} waiting on guests",
	waitingGroup_other: "{{count}} waiting on guests",
	overflow_one: "{{count}} more {{label}}",
	overflow_other: "{{count}} more {{label}}",
	page: {
		title: "Action Center",
		subtitle: "Everything waiting on you, most urgent first.",
		blockers: "Blockers",
		decisions: "Decisions",
		opportunities: "Opportunities",
		waiting: "Waiting on guests"
	},
	urgency: {
		left: "{{time}} left",
		waiting: "waiting {{time}}",
		expired: "expired"
	},
	facet: {
		guests_one: "{{count}} guest",
		guests_other: "{{count}} guests",
		stayChange: "{{from}} → {{to}}",
		nightsDelta_one: "{{count}} night added",
		nightsDelta_other: "{{count}} nights added",
		nightsDeltaRemoved_one: "{{count}} night removed",
		nightsDeltaRemoved_other: "{{count}} nights removed",
		penalties_one: "{{count}} penalty",
		penalties_other: "{{count}} penalties",
		listings_one: "{{count}} listing",
		listings_other: "{{count}} listings",
		requests_one: "{{count}} request",
		requests_other: "{{count}} requests",
		failures_one: "failed {{count}} time",
		failures_other: "failed {{count}} times"
	},
	figure: {
		YOU_EARN: "you earn",
		OUTSTANDING: "outstanding",
		DELTA: "difference",
		TOTAL: "stay total",
		AVAILABLE: "ready to withdraw"
	},
	subject: {
		BOOKING_REQUEST: "{{guest}}",
		BOOKING_REQUEST_unknown: "A guest",
		DATE_CHANGE_REQUEST: "{{guest}}",
		DATE_CHANGE_REQUEST_unknown: "A guest",
		EXTENSION_REQUEST: "{{guest}}",
		EXTENSION_REQUEST_unknown: "A guest",
		INVITATION_PENDING: "Awaiting the guest",
		OFFER_AWAITING_PAYMENT: "Awaiting payment",
		PENALTY_DEBT: "Cancellation penalties",
		PAYOUT_METHOD_MISSING: "No payout method",
		PAYOUT_REJECTED: "Payout rejected",
		LISTING_SUSPENDED_one: "{{count}} listing is suspended",
		LISTING_SUSPENDED_other: "{{count}} listings are suspended",
		VERIFICATION_REQUIRED: "Verification needed",
		VERIFICATION_REQUIRED_identity_unverified: "Verify your identity",
		VERIFICATION_REQUIRED_identity_rejected: "Identity rejected",
		VERIFICATION_REQUIRED_business_unverified: "Verify your business",
		VERIFICATION_REQUIRED_business_rejected: "Business rejected",
		UNREAD_MESSAGES_one: "{{count}} unread message from guests",
		UNREAD_MESSAGES_other: "{{count}} unread messages from guests",
		MESSAGE_REQUEST_one: "{{count}} message request to review",
		MESSAGE_REQUEST_other: "{{count}} message requests to review",
		REVIEW_UNANSWERED: "{{guest}}",
		REVIEW_UNANSWERED_unknown: "A guest",
		PROPERTY_DRAFT: "Unfinished listing",
		CALENDAR_FEED_FAILING: "Calendar sync failing",
		CALENDAR_FEED_FAILING_degraded: "Calendar sync failing",
		CALENDAR_FEED_FAILING_suspended: "Calendar sync stopped",
		ROOM_OUT_OF_ORDER_WITH_BOOKINGS_one: "Move {{count}} stay off an out-of-order room",
		ROOM_OUT_OF_ORDER_WITH_BOOKINGS_other: "Move {{count}} stays off an out-of-order room",
		ARRIVAL_ROOM_NOT_READY: "A guest arrives today and the room isn't ready",
		ARRIVAL_ROOM_NOT_READY_dirty: "A guest arrives today and the room is still dirty",
		ARRIVAL_ROOM_NOT_READY_clean: "A guest arrives today and the room isn't inspected yet"
	},
	hint: {
		PENALTY_DEBT: "Your listings stay suspended until this is paid",
		PAYOUT_METHOD_MISSING: "Your cleared balance can't be paid out yet",
		LISTING_SUSPENDED: "Suspended listings are hidden and can't be booked",
		CALENDAR_FEED_FAILING: "Imported blocks are out of date — you could be double-booked",
		PROPERTY_DRAFT: "Step {{step}} of {{totalSteps}}",
		ROOM_OUT_OF_ORDER_WITH_BOOKINGS: "Booked guests have no room until they're moved",
		ARRIVAL_ROOM_NOT_READY: "The guest could be waiting at the desk"
	}
};
//#endregion
export { e as default };
